'use strict';

var t=e=>{let r=/\s+/g;return e.trim().replace(r," ")};

exports.a = t;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-WAUX3N2G.js.map